export const BadgePremisePhaseType = (props) => {
  // input
  const { phase_type = null} = props;

  switch(phase_type) {
    // residential
    case 'single_phase': return (
      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 shadow-sm ring-1 ring-inset ring-green-500/10">
        1-Phase
      </span>
    )
    case 'three_phase': return (
      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 shadow-sm ring-1 ring-inset ring-green-500/10">
        3-Phase
      </span>
    )
    case 'three_phase_ct': return (
      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 shadow-sm ring-1 ring-inset ring-green-500/10">
        3-Phase CT
      </span>
    )
    default: return (
      <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 shadow-sm ring-1 ring-inset ring-gray-500/10">
        {phase_type ? phase_type : 'Unknown'}
      </span>
    )
  }
}